import React from 'react';

const OrderProductsPanel = ({
  formData,
  productSearch,
  products,
  errors,
  onProductSearchChange,
  onAddProduct,
  onRemoveProduct,
  onProductChange,
  wartoscNetto,
  wartoscBrutto,
}) => {
  return (
    <div style={{ marginTop: '0.5rem', backgroundColor: 'var(--card-bg)', borderRadius: '4px', border: '1px solid var(--border)' }}>
      <div style={{ padding: '0.4rem 0.5rem', backgroundColor: 'var(--border)', borderBottom: '1px solid var(--border)', borderRadius: '4px 4px 0 0' }}>
        <h4 style={{ margin: 0, fontSize: '11px', fontWeight: '600', color: 'var(--text-secondary)' }}>
          Produkty ({formData.pozycje.length})
        </h4>
      </div>

      <div style={{ padding: '0.5rem' }}>
        {/* Wyszukiwarka produktow */}
        <div style={{ backgroundColor: 'var(--bg)', border: '1px solid var(--border)', borderRadius: '4px', padding: '0.5rem', marginBottom: '0.5rem' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.4rem' }}>
            <span style={{ fontSize: '10px', fontWeight: '600', color: 'var(--text-secondary)' }}>Wyszukaj produkty</span>
            <span style={{ fontSize: '9px', color: 'var(--text-muted)' }}>Znaleziono: <strong>{products.length}</strong></span>
          </div>
          <input
            type="text"
            placeholder="Wpisz nazwe produktu lub kod kreskowy..."
            value={productSearch}
            onChange={(e) => onProductSearchChange(e.target.value)}
            autoComplete="off"
            style={{ width: '100%', padding: '6px 10px', fontSize: '12px', border: '1px solid var(--border)', borderRadius: '6px', backgroundColor: 'var(--card-bg)', color: 'var(--text)' }}
          />
          {productSearch.length >= 2 && (
            <div style={{ maxHeight: '180px', overflowY: 'auto', marginTop: '0.4rem' }}>
              {products.length === 0 ? (
                <div style={{ padding: '1rem', textAlign: 'center', color: 'var(--text-muted)', fontSize: '11px' }}>Nie znaleziono produktow</div>
              ) : (
                products.map((product, index) => (
                  <div
                    key={product.id}
                    onClick={() => onAddProduct(product)}
                    style={{
                      padding: '0.4rem 0.5rem', cursor: 'pointer', borderBottom: '1px solid var(--border)',
                      backgroundColor: index % 2 === 0 ? 'var(--card-bg)' : 'var(--bg)',
                      display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '10px'
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: '600' }}>{product.name || product.nazwa}</div>
                      <div style={{ color: 'var(--text-muted)', fontSize: '9px' }}>
                        {product.barcode && `EAN: ${product.barcode} | `}ID: {product.id}
                      </div>
                    </div>
                    <div style={{ textAlign: 'right' }}>
                      {product.has_special_price === 1 ? (
                        <div>
                          <div style={{ fontWeight: '600', color: 'var(--success)' }}>
                            {parseFloat(product.special_price_brutto).toFixed(2)} zl *
                          </div>
                          <div style={{ fontSize: '9px', color: 'var(--text-muted)', textDecoration: 'line-through' }}>
                            {parseFloat(product.default_price_brutto).toFixed(2)} zl
                          </div>
                        </div>
                      ) : (
                        <div style={{ fontWeight: '600', color: 'var(--success)' }}>
                          {parseFloat(product.price || product.default_price_brutto || 0).toFixed(2)} zl
                        </div>
                      )}
                      <div style={{ fontSize: '9px', color: 'var(--text-muted)' }}>{product.unit || product.jednostka || 'szt'}</div>
                    </div>
                  </div>
                ))
              )}
            </div>
          )}
        </div>

        {/* Tabela produktow */}
        {formData.pozycje.length === 0 ? (
          <div style={{ padding: '1.5rem', textAlign: 'center', color: 'var(--text-muted)', fontSize: '11px' }}>
            <p style={{ margin: 0 }}>Brak produktow w zamowieniu</p>
          </div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '10px' }}>
              <thead style={{ backgroundColor: 'var(--bg)' }}>
                <tr>
                  <th style={{ width: '40%', padding: '0.4rem 0.5rem', textAlign: 'left', borderBottom: '1px solid var(--border)' }}>Produkt</th>
                  <th style={{ width: '15%', padding: '0.4rem 0.5rem', textAlign: 'left', borderBottom: '1px solid var(--border)' }}>Ilosc</th>
                  <th style={{ width: '15%', padding: '0.4rem 0.5rem', textAlign: 'left', borderBottom: '1px solid var(--border)' }}>Cena</th>
                  <th style={{ width: '15%', padding: '0.4rem 0.5rem', textAlign: 'left', borderBottom: '1px solid var(--border)' }}>Wartosc</th>
                  <th style={{ width: '10%', padding: '0.4rem 0.5rem', textAlign: 'left', borderBottom: '1px solid var(--border)' }}>Uwagi</th>
                  <th style={{ width: '5%', padding: '0.4rem 0.5rem', textAlign: 'center', borderBottom: '1px solid var(--border)' }}>Akcje</th>
                </tr>
              </thead>
              <tbody>
                {formData.pozycje.map((pozycja, index) => (
                  <tr key={index}>
                    <td style={{ padding: '0.3rem 0.5rem' }}>
                      <div>
                        <span style={{ fontWeight: '600', fontSize: '10px' }}>{pozycja.produkt_nazwa}</span>
                        {pozycja.has_special_price === 1 && (
                          <div style={{ fontSize: '9px' }}>
                            <span style={{ color: 'var(--success)' }}>Cena specjalna: {parseFloat(pozycja.special_price_brutto).toFixed(2)} zl</span>
                            <br />
                            <span style={{ color: 'var(--text-muted)', textDecoration: 'line-through' }}>Regularna: {parseFloat(pozycja.default_price_brutto).toFixed(2)} zl</span>
                          </div>
                        )}
                      </div>
                    </td>
                    <td style={{ padding: '0.3rem 0.5rem' }}>
                      <input
                        type="number"
                        style={{ width: '100%', padding: '0.25rem 0.4rem', fontSize: '10px', border: errors[`pozycja_${index}_ilosc`] ? '1px solid var(--danger)' : '1px solid var(--border)', borderRadius: '3px' }}
                        value={pozycja.ilosc}
                        onChange={(e) => onProductChange(index, 'ilosc', e.target.value)}
                        min="0.01" step="0.01"
                      />
                      {errors[`pozycja_${index}_ilosc`] && <div style={{ color: 'var(--danger)', fontSize: '9px' }}>{errors[`pozycja_${index}_ilosc`]}</div>}
                    </td>
                    <td style={{ padding: '0.3rem 0.5rem' }}>
                      <input
                        type="number"
                        style={{ width: '100%', padding: '0.25rem 0.4rem', fontSize: '10px', border: errors[`pozycja_${index}_cena`] ? '1px solid var(--danger)' : '1px solid var(--border)', borderRadius: '3px' }}
                        value={pozycja.cena_jednostkowa}
                        onChange={(e) => onProductChange(index, 'cena_jednostkowa', e.target.value)}
                        min="0" step="0.01"
                      />
                      {errors[`pozycja_${index}_cena`] && <div style={{ color: 'var(--danger)', fontSize: '9px' }}>{errors[`pozycja_${index}_cena`]}</div>}
                    </td>
                    <td style={{ padding: '0.3rem 0.5rem' }}>
                      <span style={{ fontWeight: '600', fontSize: '10px' }}>
                        {((pozycja.ilosc || 0) * (pozycja.cena_jednostkowa || 0)).toFixed(2)} zl
                      </span>
                    </td>
                    <td style={{ padding: '0.3rem 0.5rem' }}>
                      <input
                        type="text"
                        style={{ width: '100%', padding: '0.25rem 0.4rem', fontSize: '10px', border: '1px solid var(--border)', borderRadius: '3px' }}
                        value={pozycja.uwagi_pozycja || ''}
                        onChange={(e) => onProductChange(index, 'uwagi_pozycja', e.target.value)}
                        placeholder="Uwagi..."
                      />
                    </td>
                    <td style={{ padding: '0.3rem 0.5rem', textAlign: 'center' }}>
                      <button
                        type="button"
                        onClick={() => onRemoveProduct(index)}
                        style={{ padding: '4px 10px', fontSize: '11px', border: '1px solid var(--danger)', backgroundColor: 'var(--card-bg)', color: 'var(--danger)', cursor: 'pointer' }}
                      >
                        Del
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot style={{ backgroundColor: 'var(--bg)' }}>
                <tr>
                  <th colSpan="3" style={{ padding: '0.4rem 0.5rem', fontSize: '11px', fontWeight: '600' }}>Razem:</th>
                  <th style={{ padding: '0.4rem 0.5rem', fontSize: '11px' }}>
                    <div style={{ fontWeight: '600' }}>{wartoscBrutto.toFixed(2)} zl brutto</div>
                    <div style={{ color: 'var(--text-muted)', fontSize: '9px' }}>{wartoscNetto.toFixed(2)} zl netto</div>
                  </th>
                  <th colSpan="2"></th>
                </tr>
              </tfoot>
            </table>
          </div>
        )}

        {errors.pozycje && (
          <div style={{ color: 'var(--danger)', fontSize: '10px', marginTop: '0.25rem' }}>{errors.pozycje}</div>
        )}
      </div>
    </div>
  );
};

export default OrderProductsPanel;
